export default "__VITE_ASSET__d7ef37ee__"